const CheckBoxNew = ({ text, title, value, handle }) => {
  // --- STYLES ---
  const styles = {
    container: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "1px",
      gap: "10px", // Space between toggle and text
    },
    // Formerly .button_slider_new
    toggleTrack: {
      position: "relative",
      width: "36px", // Standard switch width
      height: "20px", // Standard switch height
      borderRadius: "20px",
      backgroundColor: value ? "#000" : "#bcbcbc", // Dynamic bg
      cursor: "pointer",
      transition: "background-color 0.2s ease-in-out",
      flexShrink: 0, // Prevent toggle from shrinking
    },
    // The inner white circle
    toggleKnob: {
      position: "absolute",
      top: "3px", // Vertically centered (20px height - 14px knob - 3px top)
      right: value ? "3px" : "18px", // Logic from original code
      width: "calc(50% - 3px)", // Logic from original code
      height: "calc(100% - 6px)", // Logic from original code
      backgroundColor: "white",
      borderRadius: "50%",
      transition: "right 0.1s linear",
      boxShadow: "0 1px 2px rgba(0,0,0,0.2)",
    },
    // Formerly .text_medium .noselect
    labelText: {
      fontSize: "11px", // Assuming "medium" text
      color: "#333",
      cursor: "pointer",
      userSelect: "none", // Formerly .noselect
      fontFamily: "sans-serif",
      fontWeight: 500,
    },
  };

  return (
    <div style={styles.container}>
      {/* Toggle Switch */}
      <div onClick={handle} style={styles.toggleTrack}>
        <div style={styles.toggleKnob} />
      </div>

      {/* Label Text */}
      <div onClick={handle} style={styles.labelText} data-mapid="clickGeser">
        {title}
      </div>
    </div>
  );
};

export default CheckBoxNew;
